/**
 * ng-expertiza.ru
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */

export const messages = {
    fieldRequired    : 'Заполните это поле',
    fieldInvalidEmail: 'Некорректный e-mail адрес',

    buttonTextDefault   : 'Отправить',
    buttonTextDefault2  : 'Заказать экспертизу',
    buttonTextDefault3  : 'Заказать звонок',
    buttonTextSent      : 'Отправлено',
    buttonTextSending   : 'Отправляется',
    buttonTextRequireAll: 'Заполните все поля',

    typeOfExpertize: [
        'Экспертиза проектной документации и результатов инженерных изысканий',
        'Экспертиза результатов инженерных изысканий',
        'Экспертиза проектной документации',
        'Экспертиза сметной документации',
    ],

    fields: {
        typeOfExpertize: 'Вид экспертизы',
        objectName     : 'Название объекта',
        objectAddress  : 'Адрес объекта',
        person         : 'Контактное лицо',
        telephone      : 'Телефон',
        email          : 'Электронная почта',
        message        : 'Сообщение',

        name   : 'Ваше имя',
        org    : 'Организация',
        company: 'Компания',
    },
};

export default messages;
